<template>
  <div class="t-scroll" ref="scrollWrapper">
    <div>
       <slot></slot>
    </div>
  </div>
</template>
<script>
/**
   * @param listen [Array, Object, String] 监听数据变化刷新滚动
   * @param init [Boolean] 刷新滚动是否置顶
   * @param downstart [Function] 开始下拉时触发事件
   * @param upstart [Function] 开始上拉时触发事件
   * @param pulldown [Function] 下拉释放时触发事件
   * @param pullup [Function] 上拉释放时触发事件
   * @param load [Function] 加载分页
   * @describe 分页加载完需要触发loaded方法
   *
   * @example
   *
   <better-scroll init ref="betterscroll" :listen="" @downstart="" @upstart="" @pulldown="" @pullup="" @load=""></better-scroll>
   *
*/

import Bscroll from 'better-scroll';

export default {
  name: 'betterScroll',
  props: {
    listen: [Array, Object, String],
    init: { type: Boolean, default: false },
  },
  data() {
    return {
      sliderScroll: null,
      isLock: true,
    };
  },
  created: function () {
    // 加载完调用(触发监听)this.$refs.betterscroll.$emit('loaded', isLastPage);
    this.$on('loaded', function (isLastPage) {
      this.isLock = isLastPage;
    });
  },
  mounted: function () {
    this.$nextTick(() => {
      this.initScroll();
    });
  },
  watch: {
    listen: function () {
      this.$nextTick(() => {
        this.refresh();
      });
    },
  },
  methods: {
    // 初始化滚动配置
    initScroll: function () {
      this.sliderScroll = new Bscroll(this.$refs.scrollWrapper, {
        click: true,
        probeType: 3,
      });
      // 监听滚动事件
      this.sliderScroll.on('scroll', (position) => {
        if (position.y > 0) {
          this.$emit('downstart', this.sliderScroll); // 下拉刷新中。。。
        }
        if (position.y < this.sliderScroll.maxScrollY) { // 上拉刷新中。。。
          this.$emit('upstart', this.sliderScroll);
        }
        if (position.y && position.y - 50 <= this.sliderScroll.maxScrollY && !this.isLock) { // 滚动到底部
          this.isLock = true;
          // const isLastPage = (this.form.pageSize * this.form.currentPage) >= this.form.total;
          this.$emit('load');
        }
      });
      // 监听触摸结束事件
      this.sliderScroll.on('touchEnd', (position) => {
        // 下拉刷新-加载完数据后需要调用刷新(即触发listen或listenRef绑定值变更)
        if (position.y > 30) {
          this.$emit('pulldown', this.sliderScroll);
        }
        // 上拉刷新-加载完数据后需要调用刷新(即触发listen或listenRef绑定值变更)
        if (position.y < (this.sliderScroll.maxScrollY - 30)) {
          this.$emit('pullup', this.sliderScroll);
        }
      });

    },
    // 刷新滚动
    refresh: function () {
      this.sliderScroll.refresh();
      if (this.init) {
        this.sliderScroll.scrollTo(0, 0);
      }
    },
  },
};

</script>
<style scoped lang="scss">
.t-scroll {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;
}

</style>



// WEBPACK FOOTER //
// src/components/betterscroll.vue